import xorBy from 'lodash/xorBy'
import { computed, makeObservable } from 'mobx'

import employees from 'modules/employees/store/collections/employees'
import { locationActiveEmployees } from 'modules/locations/lib/locationEmployees'
import locations from 'modules/locations/store/collections/locations'

export class Store {
  constructor(private locationId: number) {
    makeObservable(this, {
      location: computed,
      employees: computed,
    })
  }

  get location() {
    return locations.get(this.locationId)
  }

  get employees() {
    if (!this.location) return null

    return xorBy(
      locationActiveEmployees(this.location, employees),
      employees.active,
      (employee) => employee.attributes.id
    )
  }
}
